module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/HowToFileClaimSection/user-dashboard-59cee2163630d018261bf8ea5a4e8766.png";